import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "sidebar",
  class: "sidebar sidebar-fixed menu-sidebar",
  "data-simplebar-direction": "vertical"
}
const _hoisted_2 = { class: "sidebar-scroll-content border-radius-20" }
const _hoisted_3 = { class: "nav nav-list background-white" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { style: {"display":"flex"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "new-icon"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { style: {"display":"flex"} }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  style: {"margin-left":"20px"},
  class: "non-active-menu-color nav-menu-header"
}
const _hoisted_12 = { class: "side-bar-menu-description display-block" }
const _hoisted_13 = { class: "footerbranding" }
const _hoisted_14 = {
  target: "_blank",
  rel: "noreferrer",
  href: "https://ventla.io/"
}
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems.MenuItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            id: item.Id,
            key: item.Id,
            class: _normalizeClass(["menu-item", {'selected-menu-active-border': _ctx.router.name === item.ComponentName}])
          }, [
            (item.IsRouterLink)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: _ctx.$route.fullPath,
                  to: { name: item.ComponentName, params: _ctx.routeParams},
                  class: _normalizeClass({'selected-menu-active': _ctx.activeComponent === item.ComponentName})
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          class: "nav-module-icon",
                          src: _ctx.GetImageSrc(item.IconIndex, _ctx.activeComponent === item.ComponentName)
                        }, null, 8, _hoisted_6)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["margin-left-20 nav-menu-header", [_ctx.activeComponent === item.ComponentName ? 'active-menu-color' : 'non-active-menu-color']])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.Title), 1),
                        (item.Id === 'LMOrgSettings')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('New')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("small", {
                          class: _normalizeClass(["side-bar-menu-description display-block", {'active-menu-color': _ctx.activeComponent === item.ComponentName}])
                        }, _toDisplayString(item.Description), 3)
                      ], 2)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to", "class"]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _ctx.GetFullExternalUrl(item.Url),
                  class: _normalizeClass({ 'selected-menu-active': _ctx.activeComponent === item.ComponentName })
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        class: "nav-module-icon",
                        src: _ctx.GetImageSrc(item.IconIndex, _ctx.activeComponent === item.ComponentName)
                      }, null, 8, _hoisted_10)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(item.Title), 1),
                      _createElementVNode("small", _hoisted_12, _toDisplayString(item.Description), 1)
                    ])
                  ])
                ], 10, _hoisted_8))
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("a", _hoisted_14, [
          _createElementVNode("img", {
            class: "footer-img",
            src: _ctx.IconFile
          }, null, 8, _hoisted_15)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" © " + _toDisplayString(_ctx.currentYear), 1)
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.showLeftMenuBar]
  ])
}